export const getLeftMenuData = [
  {
    title: 'Home',
    key: 'dashboardAlpha',
    url: '/dashboard/alpha',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Rede Credenciada',
    key: 'defaultPages',
    icon: 'icmn icmn-file-text',
    children: [
      {
        key: 'providersDashboard',
        title: 'Dashboard',
        url: '/providers/dashboard',
        pro: false,
      },
      {
        key: 'providersEstablishments',
        title: 'Estabelecimentos',
        url: '/providers/establishments',
        pro: false,
      },
      {
        key: 'providersEstablishment',
        title: 'Estabelecimento',
        url: '/providers/establishment-details',
        pro: false,
      },
      {
        key: 'providersProfessionals',
        title: 'Profissionais',
        url: '/providers/professionals',
        pro: false,
      },
    ],
  },
  {
    title: 'Coordenção de Cuidado',
    key: 'coordinators',
    icon: 'icmn icmn-stats-bars',
    children: [
      {
        title: 'Dashboard',
        key: 'coordinatorsDashboard',
        url: '/coordinators/dashboard',
        pro: true,
      },
      {
        title: 'Pacientes',
        key: 'coordinatorsPatientes',
        url: '/coordinators/patients',
        pro: false,
      },
      {
        title: 'Paciente',
        key: 'coordinatorsPatiente',
        url: '/coordinators/patient',
        pro: true,
      },
    ],
  },
  {
    title: 'Gestão Operacional',
    key: 'blog',
    icon: 'icmn icmn-wordpress',
    children: [
      {
        title: 'Dashboard',
        key: 'operationsDashboard',
        url: '/operations/dashboard',
        pro: false,
      },
    ],
  },
  {
    divider: true,
  },
  {
    title: 'Inteligência Artificial',
    key: 'disabledItem',
    disabled: true,
    icon: 'icmn icmn-cancel-circle',
  },
]
export const getTopMenuData = [
  {
    title: 'Home',
    key: 'dashboardAlpha',
    url: '/dashboard/alpha',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Rede Credenciada',
    key: 'defaultPages',
    icon: 'icmn icmn-file-text',
    children: [
      {
        key: 'providersDashboard',
        title: 'Dashboard',
        url: '/providers/dashboard',
        pro: false,
      },
      {
        key: 'providersEstablishments',
        title: 'Estabelecimentos',
        url: '/providers/establishments',
        pro: false,
      },
      {
        key: 'providersEstablishment',
        title: 'Estabelecimento',
        url: '/providers/establishment-details',
        pro: false,
      },
      {
        key: 'providersProfessionals',
        title: 'Profissionais',
        url: '/providers/professionals',
        pro: false,
      },
    ],
  },
  {
    title: 'Coordenção de Cuidado',
    key: 'coordinators',
    icon: 'icmn icmn-stats-bars',
    children: [
      {
        title: 'Dashboard',
        key: 'coordinatorsDashboard',
        url: '/coordinators/dashboard',
        pro: true,
      },
      {
        title: 'Pacientes',
        key: 'coordinatorsPatientes',
        url: '/coordinators/patients',
        pro: false,
      },
      {
        title: 'Paciente',
        key: 'coordinatorsPatiente',
        url: '/coordinators/patient',
        pro: true,
      },
    ],
  },
  {
    title: 'Gestão Operacional',
    key: 'blog',
    icon: 'icmn icmn-wordpress',
    children: [
      {
        title: 'Dashboard',
        key: 'operationsDashboard',
        url: '/operations/dashboard',
        pro: false,
      },
    ],
  },
  {
    divider: true,
  },
  {
    title: 'Inteligência Artificial',
    key: 'disabledItem',
    disabled: true,
    icon: 'icmn icmn-cancel-circle',
  },
]
